import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { paths } from "helpers/paths";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import { Link } from "react-router-dom";
import { list as logistsList } from "sources/books/employees";
import GroupedByLogistReport from "./groupedByLogistReport";

export default class CarIdlesReport extends GroupedByLogistReport {
    openModal = (rowData) => {
        this.props.modal({
            name: "modalMap",
            title: "Место простоя машины",
            windowMod: "wide modal--vh-75",
            data: rowData,
        });
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Cell: (props) => {
                switch (props.column.id) {
                    case "bidId": {
                        return props.value ? <Link to={paths.bidShow("bid", props.value)}>{props.value}</Link> : "";
                    }
                    case "carLogistId": {
                        const { subRows } = props.row;
                        const logistName = subRows[0].original?.carLogistDisplayName || "Без логиста";
                        const rowCount = /\(\d+\)$/.test(logistName) ? "" : ` (${subRows.length})`;
                        return `${logistName}${rowCount}`;
                    }
                    case "location": {
                        return (
                            <div className="link" onClick={this.openModal.bind(this, props.row.original)}>
                                {props.value}
                            </div>
                        );
                    }
                    default:
                        return formatValue(props.value, column.clrType);
                }
            },
            ...typeSpecificProps(column),
            aggregate: () => null,
            Aggregated: () => null,
            ...(column.propertyName === "CarLogistId"
                ? {
                      Filter: reportFilterWrapper((props) => (
                          <SelectColumnFilter
                              {...props}
                              selectProps={{
                                  ...defaultMultipleSelectProps,
                                  url: logistsList,
                                  inputProps: { name: "carLogistIds" },
                                  propName: "fullNameOrEmail",
                                  components: { ValueContainer },
                              }}
                          />
                      )),
                      filter: (rows, _id, filterValue) => {
                          if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                              return rows;
                          }
                          return rows.filter((row) => filterValue.value.includes(row.values.carLogistId));
                      },
                  }
                : {}),
        };
    };

    tableExtraProps = () => {
        const { columns } = this.props.data || {};
        const hiddenColumns = columns
            .filter(
                (column) =>
                    column.isAdditionalColumn ||
                    column.isSubGroup ||
                    column.isFooterData ||
                    column.propertyName === "CarLogistDisplayName",
            )
            .map(columnName);
        return {
            initialState: {
                groupBy: ["carLogistId"],
                hiddenColumns,
            },
        };
    };
}
